module.exports = __webpack_public_path__ + "static/media/cronosscan-logo.5823cb95.svg";